import React from 'react';
import { RemoveCircleOutline as WriteOffIcon } from '@mui/icons-material';
import BlockActionConfirmationModal from './BlockActionConfirmationModal';

export interface WriteOffConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (comment?: string) => void;
  itemName?: string;
  itemCode?: string;
  itemUniqueCode?: string;
  pendingCount?: number;
  isLoading?: boolean;
}

const WriteOffConfirmationModal: React.FC<WriteOffConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  itemName,
  itemCode,
  itemUniqueCode,
  pendingCount,
  isLoading = false,
}) => {
  const isBulk = pendingCount != null && pendingCount > 0;

  return (
    <BlockActionConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemName={isBulk ? undefined : itemName}
      itemCode={isBulk ? undefined : itemCode}
      itemUniqueCode={isBulk ? undefined : itemUniqueCode}
      isLoading={isLoading}
      title={isBulk ? 'Confirmar faltantes pendientes' : 'Confirmar faltante'}
      message={
        isBulk
          ? `Se confirmarán en inventario las ${pendingCount} pieza${pendingCount !== 1 ? 's' : ''} faltante${pendingCount !== 1 ? 's' : ''} que aún no fueron procesadas. El comentario, si lo indica, se aplicará a todas.`
          : 'Se actualizará el inventario registrando el faltante de esta pieza (disponibilidad cancelada).'
      }
      confirmText={isBulk ? 'Confirmar todos' : 'Confirmar faltante'}
      loadingConfirmText="Confirmando..."
      icon={<WriteOffIcon />}
      commentPlaceholder={
        isBulk
          ? 'Ej: Faltantes confirmados tras conteo físico'
          : 'Ej: No encontrada en conteo, posible robo, error de registro...'
      }
    />
  );
};

export default WriteOffConfirmationModal;
